import React, { useState, useEffect, useContext } from 'react';
import { Link, useParams, useNavigate } from "react-router-dom";
import ofertasServices from '../services/ofertasServices';
import { InputContext } from '../contexts/InputContext';
import { errorClassification } from '../errorHandler';

const MisPostulaciones = () => {
  const navigate = useNavigate();
  const [authInformation, setAuthInformation] = useContext(InputContext)
  const [postulaciones, setPostulaciones] = useState([]);
  const [renderHTML, setRenderHTML] = useState(false);

  useEffect(() => {
    misPostulaciones()
  }, []);

  useEffect(() => {
    // const tieneOferta =  Object.keys(oferta).includes("titulo")

    if(authInformation.autenticado === false){
      navigate(`/ingreso`);
    } else if( authInformation.autenticado === true ){
      setRenderHTML(authInformation.rol === 'Registrado')
    }

  }, [authInformation, postulaciones]);

  const misPostulaciones = async () => {
    try {
      const data = await ofertasServices.misPostulaciones();

      setPostulaciones(data);
    } catch (error) {
      const result = errorClassification(error)
      if(result.modal){
        alert(result.message)
      }
    }
  };

  const borrarPostulacion = async (id) => {
    try {
      if(window.confirm(`Está seguro que quiere eliminar su postulación?`)){
        await ofertasServices.borrarPostulacion(id);

        const copiaPostulaciones = [...postulaciones];
        setPostulaciones(copiaPostulaciones.filter((postulacion) => postulacion.id !== id))
      }
    } catch (error) {
      const result = errorClassification(error)
      if(result.modal){
        alert(result.message)
      }
    }
  };

  return (
    <div>
      {
      renderHTML &&  (
        <>
          <h1>Mis postulaciones</h1>
          <div className="table-responsive small">
            <table className="table table-striped table-sm">
              <thead>
                <tr>
                  <th scope="col">Concurso</th>
                  <th scope="col"><div className='text-end'>Acción</div></th>
                </tr>
              </thead>
              <tbody>
                {
                  postulaciones.map((postulacion, index) => (
                    <tr key={index}>
                        <td>{postulacion.oferta.titulo}</td>
                        <td className='text-end'>
                          <Link className="btn btn-primary" to={`/oferta/${postulacion.oferta.id}`}>Ver detalle</Link>{' '}
                          <button className="btn btn-danger" onClick={() => borrarPostulacion(postulacion.id)} >Eliminar</button>
                        </td>
                    </tr>
                  ))
                }
              </tbody>
            </table>
          </div>
        </>
      )
      }
    </div>
  );
};

export default MisPostulaciones;